import { Box, CircularProgress, Link } from '@mui/material';
import { AttachFile } from '@mui/icons-material';
import React from 'react';
import { FBFileFieldProps } from '..';
import { withFBAttachmentField } from './FBFileField.wrap';

const FBFileFieldIcon: React.FunctionComponent<FBFileFieldProps> = ({
  name = '',
  multiple = true,
  isLoading = false,
  onChange,
  disabled,
}) => (
  <>
    <input
      accept="*"
      type="file"
      id={`fb-attachment-field-${name}`}
      style={{ display: 'none' }}
      {...{ onChange, multiple, disabled }}
    />
    <label htmlFor={`fb-attachment-field-${name}`}>
      <Link component="span" variant="button">
        <Box pl={1} display="flex" flexDirection="row">
          {isLoading && <Box mt={0.3} mr={1}><CircularProgress size={18} /></Box>}
          {!isLoading && <AttachFile width={20} height={20} />}
        </Box>
      </Link>
    </label>
  </>
);

export default withFBAttachmentField(FBFileFieldIcon);
